<template>
  <div
    v-if="isVisible"
    class="notification-banner"
    :class="`notification-banner-${type}`"
  >
    <slot />

    <SvgIcon
      name="components/close-alt2"
      width="16"
      height="16"
      class="close"
      @click="close"
    />
  </div>
</template>

<script>
import SvgIcon from 'vue-svgicon/dist/components/svgicon.common'

import '../../icons/components/close-alt2'

export default {
  components: {
    SvgIcon,
  },
  props: {
    /**
     * Applies one of the style type to the component.
     */
    type: {
      type: String,
      default: 'info',
      validator: (value) =>
        ['info', 'success', 'warning', 'error'].indexOf(value) !== -1,
    },
  },
  data: () => ({
    isVisible: true,
  }),
  methods: {
    close (e) {
      this.isVisible = false

      /**
       * Event triggered by user interaction. Emitted after the close icon is clicked.
       */
      this.$emit('close', e)
    },
  },
}
</script>

<style lang="scss">
.notification-banner {
  position: relative;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: $font-size-sm;
  background-color: $gray-200;

  &.global-notification-banner.special {
    height: 4rem;
  }

  a {
    margin-left: 4px;
    &,
    &:hover {
      color: $cyan-700;
    }
  }

  .close {
    position: absolute;
    top: 0.75rem;
    right: 1.5rem;
    cursor: pointer;
  }

  &-info {
    background-color: $cyan-200;
  }

  &-warning {
    background-color: $orange-200;
  }

  &-error {
    background-color: $red-200;

    a {
      &,
      &:hover {
        color: $red-500;
      }
    }
  }

  &-success {
    background-color: $green-200;

    a {
      &,
      &:hover {
        color: $green-700;
      }
    }
  }
}

.global-notification-banner {
  padding: 2rem 0;

  .close {
    top: 1.5rem !important;
  }

  &.special,
  &.special-big {
    text-align: center;
    color: #fff;
    z-index: 500;

    background-size: cover;
    background-position: initial;
    background-repeat: no-repeat;

    a {
      font-family: $font-family-base;
      font-weight: normal;
      color: $cyan-500;
    }

    @include media-breakpoint-down(sm) {
      height: 4rem;
      padding: 0.5rem;

      .close {
        display: none;
      }
    }
  }

  &.special {
    font-size: 16px;
    font-weight: 500;
    padding: 0.5rem 46px;
    height: 4rem;
    background-image: url('https://cdn.tellimer.com/welcome/bg-banner-special.png');

    .close {
      display: none;
    }
  }

  &.special-big {
    background-image: url('https://cdn.tellimer.com/welcome/bg-banner-special-big.png');

    h1 {
      margin-bottom: 0.25rem;
      font-size: 24px;
      font-weight: bold;
      color: #fff;
    }

    .close {
      top: 56px !important;
    }

    @include media-breakpoint-up(sm) {
      padding: 2rem 3rem;
      height: 128px !important;
    }

    @include media-breakpoint-down(sm) {
      height: 4rem !important;

      h1 {
        margin-bottom: 0;
        font-size: 14px;
        font-weight: 500;
        display: inline;
        margin-right: 0.25rem;
      }
    }
  }

  &.notification-banner {
    font-size: 1rem;

    &-error {
      background-color: $red-500;
      color: #fff;
    }

    @include media-breakpoint-down(sm) {
      font-size: 0.875rem;
    }
  }

  .notification-link {
    text-decoration: none;
    color: $cyan-700;
    &:hover,
    &:active {
      color: $cyan-700;
      text-decoration: none;
    }
  }
}

</style>
